import { state as stateConstants, actions } from 'src/constants';
import api from 'src/core/api';

import { getActionType } from './helper';

const {
  IDENTIFIER_TYPE_LIST,
  IDENTIFIER_TYPE_DETAILS,
  IDENTIFIER_TYPE_ITEM
} = stateConstants;

export const getList = (resource) => (payload, meta = {}) => {
  const actionType = getActionType(
    actions.ACTION_GET,
    resource.NAME,
    IDENTIFIER_TYPE_LIST
  );
  const { url, dataPath } = resource.getListConfig(payload);
  const options = { ...api.http.get(), dataPath };

  return api.request(actionType, url, options, meta);
};

export const getDetails = (resource) => (payload, meta = {}) => {
  const apiConfig = resource.getDetailsConfig ? resource.getDetailsConfig(payload) : meta;

  const actionType = getActionType(
    actions.ACTION_GET,
    resource.NAME,
    IDENTIFIER_TYPE_DETAILS
  );
  const { url, dataPath } = apiConfig;
  const options = { ...api.http.get(), dataPath };

  return api.request(actionType, url, options, meta);
};

export const deleteResource = (resource) => (payload, meta = {}) => {
  const actionType = getActionType(
    actions.ACTION_DELETE,
    resource.NAME,
    IDENTIFIER_TYPE_ITEM
  );
  const { url } = resource.getDeleteConfig(payload);
  const options = api.http.delete(payload);

  return api.request(actionType, url, options, meta);
};

export const createResource = (resource, customAction) => (payload, meta = {}) => {
  const action = customAction || actions.ACTION_CREATE;
  const actionType = getActionType(
    action,
    resource.NAME,
    IDENTIFIER_TYPE_ITEM
  );
  let getConfig = resource.getCreateConfig;
  let requestMethod = api.http.post;

  if (customAction === actions.ACTION_PATCH) {
    getConfig = resource.getPatchConfig;
    requestMethod = api.http.patch;
  }

  if (customAction === actions.ACTION_PUT) {
    getConfig = resource.getPutConfig;
    requestMethod = api.http.put;
  }

  const config = getConfig ? getConfig(payload, meta) : meta;
  const options = requestMethod(payload, config.stringify, config.headers);
  const url = meta.url || config.url;

  return api.request(actionType, url, options, meta, payload);
};

export const patchResource = (resource, customAction) => (payload, meta = {}) => createResource(
  resource,
  customAction || actions.ACTION_PATCH
)(payload, meta);

export const putResource = (resource, customAction) => (payload, meta = {}) => createResource(
  resource,
  customAction || actions.ACTION_PUT
)(payload, meta);

export const updateResource = (resource) => (payload, meta = {}) => {
  const actionType = getActionType(
    actions.ACTION_UPDATE,
    resource.NAME,
    IDENTIFIER_TYPE_ITEM
  );
  const config = resource.getUpdateConfig ? resource.getUpdateConfig() : meta;

  const { url, dataPath } = config;
  const options = { ...api.http.post(payload), dataPath };

  return api.request(actionType, url, options, meta);
};
